// src/layout/Layout.js
import { Outlet } from 'react-router-dom';
import Footer from '../components/HiTech/Footer.js';
import Header from '../components/HiTech/Header.js';

// import Footer from '../components/Course/Footer.js';
// import Header from '../components/Course/Header.js';

export default function Layout() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main className="flex-grow-1">
        <Outlet />
        {/* <Home /> */}
      </main>
      <Footer />
    </div>
  );
}
